import type { DocumentItemInput, InvoiceItem, QuoteItem, Tax } from "./billing-types";
import { fromMajorInput, fromMajorQuantity, fromPercentToBp, toMajorInput, toMajorQuantity } from "./format";

export interface ItemDraft {
  key: string;
  product_id: string;
  description: string;
  quantity: string;
  unit_price: string;
  discount_percent: string;
  tax_id: string;
}

export function emptyItemDraft(key: string): ItemDraft {
  return {
    key,
    product_id: "",
    description: "",
    quantity: "1",
    unit_price: "0.00",
    discount_percent: "",
    tax_id: "",
  };
}

export function draftFromItem(item: QuoteItem | InvoiceItem, key: string): ItemDraft {
  return {
    key,
    product_id: item.product_id ?? "",
    description: item.description,
    quantity: toMajorQuantity(item.quantity_milli),
    unit_price: toMajorInput(item.unit_price_minor),
    discount_percent: item.discount_bp === 0 ? "" : String(item.discount_bp / 100),
    tax_id: item.tax_id ?? "",
  };
}

export function toDocumentItemInputs(items: ItemDraft[], taxes: Tax[]): DocumentItemInput[] {
  return items.map((item, index) => {
    const tax = item.tax_id === "" ? undefined : taxes.find((row) => row.id === item.tax_id);
    return {
      product_id: item.product_id === "" ? null : item.product_id,
      description: item.description.trim(),
      quantity_milli: fromMajorQuantity(item.quantity),
      unit_price_minor: fromMajorInput(item.unit_price),
      discount_bp: fromPercentToBp(item.discount_percent),
      tax_id: tax?.id ?? null,
      tax_rate_bp: tax?.rate_bp ?? 0,
      tax_name: tax?.name ?? null,
      sort_order: index,
    };
  });
}
